import React from 'react';
import { Section } from './ui/Section';
import { useLanguage } from '../context/LanguageContext';
export function ProblemAgitation() {
  const {
    t
  } = useLanguage();
  return <Section background="charcoal" data-id="element-99">
      <div className="text-center mb-16" data-id="element-100">
        <h2 className="font-serif text-3xl md:text-5xl text-white" data-id="element-101">
          {t.problemAgitation.headline.line1} <br data-id="element-102" />
          <span className="italic text-luxury-gold" data-id="element-103">
            {t.problemAgitation.headline.span}
          </span>
        </h2>
      </div>

      <div className="grid md:grid-cols-2 gap-0 border border-luxury-gold/20" data-id="element-104">
        {/* Left Column - The Influencer */}
        <div className="p-12 md:p-16 border-b md:border-b-0 md:border-r border-luxury-gold/20 bg-luxury-black/50" data-id="element-105">
          <h3 className="font-serif text-3xl text-luxury-gray mb-8" data-id="element-106">
            {t.problemAgitation.influencer.title}
          </h3>
          <ul className="space-y-6" data-id="element-107">
            {t.problemAgitation.influencer.items.map((item, i) => <li key={i} className="flex items-start text-luxury-gray/60 font-light" data-id="element-108">
                <span className="mr-4 text-luxury-gray/40" data-id="element-109">•</span>
                {item}
              </li>)}
          </ul>
        </div>

        {/* Right Column - The Brand Operator */}
        <div className="p-12 md:p-16 bg-luxury-charcoal relative overflow-hidden" data-id="element-110">
          <div className="absolute top-0 right-0 w-24 h-24 bg-luxury-gold/5 rounded-bl-full" data-id="element-111" />

          <h3 className="font-serif text-3xl text-white mb-8" data-id="element-112">
            {t.problemAgitation.brandOperator.title}
          </h3>
          <ul className="space-y-6" data-id="element-113">
            {t.problemAgitation.brandOperator.items.map((item, i) => <li key={i} className="flex items-start text-white font-medium" data-id="element-114">
                <span className="mr-4 text-luxury-gold" data-id="element-115">•</span>
                {item}
              </li>)}
          </ul>
        </div>
      </div>

      <div className="text-center mt-12" data-id="element-116">
        <p className="text-luxury-gold uppercase tracking-widest text-sm" data-id="element-117">
          {t.problemAgitation.footer}
        </p>
      </div>
    </Section>;
}